export default function handleOnBlur(onChange, onBlur, value, searchValue, allowIncompleteValue) {
  return (event) => {
    onBlur(event);
    if (allowIncompleteValue && !value?.value && searchValue) {
      onChange({ target: { value: { label: searchValue, value: undefined } } });
    }
  };
}
